export const aminoacidos = (index) =>{
	const data = [
		{
			'name':"Alanina" ,
			'info':[
				"Embora apolar, situa-se tanto no interior como na superfície das proteínas.",
				"Aminoácido não essencial; possui um grupo metil como cadeia lateral; comum em alfa hélices."
			]
		},
		{
			'name':"Arginina" ,
			'info':[
				"O mais básico, contém um grupo guanidina e forma pontes salinas.",
				"Aminoácido não essencial em animais adultos; hidrofílico, é raro no interior da molécula (exceto quando forma pontes salinas); freqüentemente interage com grupos fosfato de proteínas de membrana; comum na última volta de alfa hélices."
			]
		},
		{
			'name':"Asparagina" ,
			'info':[
				"Hidrofílico; derivado do Aspartato; presente em sítios de N-glicosilação.",
				"Aminoácido não essencial; sua cadeia lateral é um grupo metilamida capaz de imitar uma ligação peptídica; derivado de um aminoácido ácido (Aspartato); forma pontes de hidrogênio com a cadeia principal."
			]
		},
		{
			'name':"Aspartato" ,
			'info':[
				"Ácido, envolvido na ligação de metais e em pontes de hidrogênio.", 
				"Aminoácido não essencial; hidrofílico, não é comum no interior das proteínas (exceto quando em pontes salinas); a cadeia lateral é um grupo metil-carboxil; parecido com sua amida derivada (Asparagina) na capacidade de formar pontes de hidrogênio com a cadeia principal."
			]
		},
		{
			'name':"Cisteína" ,
			'info':[
				"Apesar de polar, pode formar ligação dissulfeto hidrofóbica; liga metais.",
				"Aminoácido não essencial; possui um grupo sulfidril em sua cadeia lateral; único que forma pontes dissulfeto, podendo unir covalentemente duas cadeias polipeptídicas; apesar da sulfidrila lhe conferir polaridade, a ligação dissulfeto entre dois resíduos é altamente hidrofóbica; raro em hélices alfa."
			]
		},
		{
			'name':"Fenilalanina" ,
			'info':[
				"Altamente hidrofóbico; comum em alfa hélices e folhas beta.",
				"Aminoácido essencial; cadeia lateral composta por um um anel aromático (grupo fenil) ligado a uma metila; absorve muito pouco de luz ultravioleta."
			] 
		},
		{
			'name':"Glicina" ,
			'info':[
				"Apolar e flexível; único simétrico, de menor cadeia lateral.",
				"Aminoácido não essencial, embora não polar, sua cadeia pequena não exerce reais contribuições às interações hidrofóbicas; flexível, situa-se comumente em regiões que não acomodariam nenhum outro aminoácido."
			]	 
		},
		{	
			'name':"Glutamato" 
			,'info':[
				"Ácido, envolvido na ligação de metais; pode formar pontes salinas.",
				"Aminoácido não essencial; hidrofílico, é raramente encontrado no interior da molécula (menos quando formando pontes salinas); a cadeia lateral é um grupo etil-carboxil; possui um aminoácido amida derivado (Glutamina); comum na primeira volta de alfa hélice."
			]
		},
		{	
			'name':"Glutamina" 
			,'info':[
				"Hidrofílico, derivado do Glutamato; pode formar pontes de hidrogênio.",
				"Aminoácido não essencial; sua cadeia lateral é um grupo etilamida capaz de formar pontes de hidrogênio com a cadeia principal; derivado de um aminoácido ácido (Glutamato)."
			]
		},
		{
			'name':"Histidina" ,
			'info':[
				"Básico; comum em sítios ativos de enzimas, pKa próximo à neutralidade.",
				"Aminoácido essencial; possui um anel imidazol; pode atuar como um carregador de prótons; freqüentemente encontrado em regiões de ligação com metais e em sítios ativos de enzimas."
			] 
		},
		{
			'name':"Isoleucina" ,
			'info':[
				"Altamente apolar; comum em alfa hélices e folhas beta; dois centros quirais.",
				"Aminoácido essencial; devido à sua cadeia lateral alifática apolar altamente hidrofóbica, encontra-se no interior da molécula."
			]
		},
		{
			'name':"Leucina" ,
			'info':[
				"Altamente hidrofóbico, é comum em alfa hélices e folhas beta.",
				"Aminoácido essencial; cadeia lateral alifática constituída por um grupo isobutil apolar; é normalmente encontrado no interior das proteínas."
			] 
		},
		{
			'name':"Lisina" ,
			'info':[
				"Básico, é muito flexível; pode formar pontes salinas.",
				"Aminoácido essencial, hidrofílico, é raro no interior das proteínas (exceto quando forma pontes salinas); possui um grupo amino primário na sua cadeia lateral; freqüentemente envolvido em interações com grupos fosfato de proteínas de membrana; comum na última volta de alfa hélices."
			]
		},
		{
			'name':"Metionina" ,
			'info':[
				"Hidrofóbico, é comum em alfa hélices e folhas beta; contém enxofre.",
				"Aminoácido essencial; possui cadeia lateral longa contendo enxofre (grupo tioéter); encontra-se normalmente no interior das proteínas."
			]
		},
		{	
			'name':"Prolina" 
			,'info':[
				"Aminoácido rígido levemente polar; comum nos pontos de dobra de peptídeo.",
				"Aminoácido não essencial; embora quimicamente apolar, não é averso à exposição à água; cadeia lateral pequena e ciclizada; rígido, reduz a flexibilidade estrutural do polipeptídeo; localiza-se geralmente nos pontos de dobra da cadeia, sendo raro tanto em alfa hélices como em folhas beta."
			]
		},
		{
			'name':"Serina" ,
			'info':[
				"Hidrofílico, é reativo no sítio catalítico de certas enzimas.",
				"Aminoácido não essencial; cadeia lateral formada por um grupo metil e uma hidroxila, comum em sítios de fosforilação e glicosilação e em voltas beta, “loops” e regiões desordenadas." 
			]
		}, 
		{
			'name':"Tirosina" ,
			'info':[
				"Levemente polar; comum em folhas beta e sítios de reconhecimento protéico de DNA.",
				"Aminoácido não essencial, porém derivado da fenilalanina; possui um anel aromático hidroxilado na cadeia lateral; frequentemente encontrado nos sítios ativos de algumas enzimas; absorve luz ultravioleta em intensidade média."
			]
		},
		{
			'name':"Treonina" ,
			'info':[
				"Hidrofílico, comum em sítios de fosforilação e glicosilação; dois centros quirais.",
				"Aminoácido essencial; cadeia lateral hidroxilada; comum em folhas beta."
			]
		},
		{
			'name':"Triptofano" ,
			'info':[
				"Hidrofóbico, absorve luz ultravioleta com grande intensidade.",
				"Aminoácido essencial; encontra-se no interior das proteínas; contém dois anéis aromáticos (grupo indol) em sua cadeia lateral."
			]
		}, 
		{
			'name':"Valina" ,
			'info':[
				"Apolar com cadeia alifática pequena; comum em alfa hélices e folhas beta.",
				"Aminoácido essencial; hidrofóbico, é normalmente encontrado no interior da molécula; sua cadeia alifática pequena é um isopropil."
			]
		}
	]

	return data[index]
}